import React from "react";
import { MoonLoader } from "react-spinners";
import "./Loading.css"

const Loading = () => {
    return (
        <div className="loading-container">
            <MoonLoader color="#ffffff" size={100} />
        </div>
    );
};

export default Loading;
